import { jwtDecode } from 'jwt-decode'

export function decodeUserName(token) {
    if (!token) return ''
    try {
        const decoded = JSON.parse(token)
        if (decoded.firstName && decoded.lastName) {
            return `${decoded.firstName} ${decoded.lastName}`
        }
        return decoded.username || ''
    } catch {
        return ''
    }
}

export function decodeUserId(token) {
    const decoded = jwtDecode(token) || {}
    return decoded['user_id'] ?? decoded['userId'] ?? decoded['sub'] ?? null
}

export function decodeUserEmail(token) {
    const decoded = jwtDecode(token) || {}
    return decoded.email ?? null
}

// Returns a display-ready full name string for a given user-like object.
// Accepts either a plain user object or a wrapper { user: {...} }.
export function getUserFullName(rawUser) {
    if (!rawUser) return ''

    const user = rawUser.user || rawUser

    const firstName = user.firstName || user.first_name || ''
    const lastName = user.lastName || user.last_name || ''
    const username = user.username || ''

    const combined = `${firstName} ${lastName}`.trim()

    if (combined) {
        return combined
    }

    return username
}

export function getUserFirstAndLastName(rawUser, fallbackFullName = '') {
    const user = rawUser?.user || rawUser || {}
    const firstName = user.firstName || user.first_name || ''
    const lastName = user.lastName || user.last_name || ''

    if (firstName || lastName) {
        return {
            firstName: firstName ? String(firstName).trim() : null,
            lastName: lastName ? String(lastName).trim() : null
        }
    }

    const [fallbackFirstName, ...fallbackLastNameParts] = String(fallbackFullName || '')
        .trim()
        .split(' ')

    return {
        firstName: fallbackFirstName || null,
        lastName: fallbackLastNameParts.join(' ') || null
    }
}

export function getPeopleNamesList(people) {
    if (!Array.isArray(people) || people.length === 0) {
        return []
    }

    return people.map((person) => getUserFullName(person)).filter((name) => name && name.trim().length > 0)
}
